var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameworks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 48.799,
    viewBox: "0 0 45 48.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "frameworks",
    d: "M40.872,8.532l-12.3-7.1a10.233,10.233,0,0,0-10.2,0l-12.3,7.1a10.231,10.231,0,0,0-5.1,8.835v14.2a10.235,10.235,0,0,0,5.1,8.837l12.3,7.1a10.227,10.227,0,0,0,10.2,0l12.3-7.1a10.235,10.235,0,0,0,5.1-8.837v-14.2a10.231,10.231,0,0,0-5.1-8.835ZM20.412,4.968a6.121,6.121,0,0,1,6.121,0l12.3,7.1a6.009,6.009,0,0,1,.875.673L27.07,20.034a7.2,7.2,0,0,1-7.195,0L7.239,12.74a6.009,6.009,0,0,1,.875-.673Zm-12.3,31.9a6.138,6.138,0,0,1-3.061-5.305v-14.2A5.9,5.9,0,0,1,5.2,16.276L17.835,23.57a11.2,11.2,0,0,0,3.6,1.3V44.391a5.9,5.9,0,0,1-1.02-.42Zm33.778-5.305a6.138,6.138,0,0,1-3.061,5.305l-12.3,7.1a5.9,5.9,0,0,1-1.02.42V24.866a11.2,11.2,0,0,0,3.6-1.3l12.636-7.295a5.9,5.9,0,0,1,.145,1.092Z",
    transform: "translate(-0.973 -0.069)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameworks);
export default __webpack_public_path__ + "static/media/frameworks.c65c031e66f5571dff0e0cb2e85c7c5b.svg";
export { ForwardRef as ReactComponent };